// extracted by mini-css-extract-plugin
export default {"launchedSubCategoriesStack":"LaunchedSubCategoriesPage_launchedSubCategoriesStack__seWzQ"};